import { BASE_PATH, SURVEY_BASICS_PATH } from 'routes/paths';

import { SelectUserOption } from './types';

export const HEADING = 'Help us personalize your search';
export const SUBHEADING = 'Who are you shopping for?';
export const ANALYTICS_SOURCE = 'select-user';
export const OPTIONS = [SelectUserOption.Myself, SelectUserOption.SomeoneElse];
export const SIGN_OUT_URL = `${process.env.REACT_APP_PG_MONOLITH_HOST}/users/sign_out?redirect_to=${BASE_PATH}${SURVEY_BASICS_PATH}`;
